import React, { useState } from 'react';

import { AlineButton, RemindRecipientsDialog } from 'src/components';
import { Apollo } from 'src/gql/generated';
import type { WorkflowStep } from 'src/workflow';
import { ActionGroupActionList, SigningGroupHeader, SigningGroupHeaderSection } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  card: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
  },
}));

interface DraggableActionGroupProps {
  isActiveGroup: boolean;
  step: WorkflowStep;
  stepNumber: number;
  workflowId: UUID;
  workflowState: Apollo.WorkflowState;
}

export function ActionGroupElement({
  isActiveGroup,
  step,
  stepNumber,
  workflowId,
  workflowState,
}: DraggableActionGroupProps): JSX.Element {
  const { classes } = useStyles();
  const inSigning = workflowState === Apollo.WorkflowState.Signing;
  const [hasNewActionRow, setNewActionRow] = useState<boolean>(false);

  return (
    <div className={classes.card}>
      <SigningGroupHeader
        cardAction={
          <>
            {inSigning && isActiveGroup && <RemindButton workflowId={workflowId} />}
            <SigningGroupHeaderSection setNewActionRow={setNewActionRow} workflowId={workflowId} />
          </>
        }
        isActiveGroup={isActiveGroup}
        setNewActionRow={setNewActionRow}
        step={step}
        stepNumber={stepNumber}
        workflowId={workflowId}
        workflowState={workflowState}
      />
      <ActionGroupActionList
        hasNewActionRow={hasNewActionRow}
        setNewActionRow={setNewActionRow}
        step={step}
        workflowId={workflowId}
        workflowState={workflowState}
      />
    </div>
  );
}

function RemindButton({ workflowId }: { workflowId: UUID }): JSX.Element | null {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AlineButton color="primary" variant="outlined" onClick={() => setIsOpen(true)}>
        Remind
      </AlineButton>
      <RemindRecipientsDialog
        isOpen={isOpen}
        workflowId={workflowId}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
